<template>
	<div>
		<j-expendable-box class="bg5 b1 bc7 r2">
			<!-- Header -->
			<div
				slot="header"
				class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7"
			>{{ $t("credentials") }}</div>

			<!-- Body -->
			<div class="bt1 bc7" slot="body">
				<j-list :list="computedFields">
					<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
						<!-- Label -->
						<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">{{ item.label }}</div>

						<!-- Value -->
						<div class="flex xs-4 xs-left xs-middle lh125">{{ item.value }}</div>

						<!-- Actions -->
						<div class="flex xs-2 xs-right xs-middle">
							<crm-icon
								name="edit"
								color="c2"
								class="cu2"
								v-if="item.hasUpdate"
								@click.native="handleUpdateItem(item.key)"
							/>
							<crm-icon
								name="delete"
								color="cError"
								class="ml2 cu2"
								v-if="item.hasDelete"
							/>
						</div>
					</div>
				</j-list>
			</div>
		</j-expendable-box>

		<!-- Modal -->
		<core-modal name="offerCredentialsUpdate" :headline="$t('update')">
			<div class="p4">
				<core-form-input
					v-if="itemUpdate === 'status'"
					name="name"
					componentName="j-base-input-text"
					:label="$t('status')"
					v-model="form.status"
				/>
				<core-form-input
					v-if="itemUpdate === 'startDate'"
					componentName="j-base-date-picker-simple"
					:label="$t('start_date')"
					v-model="form.startDate"
				/>
				<core-form-input
					v-if="itemUpdate === 'endDate'"
					name="offerDetailEndDate"
					componentName="j-base-date-picker-simple"
					:label="$t('end_date')"
					v-model="form.endDate"
				/>
				<j-button
					@click="updateOffer(itemUpdate)"
					class="mt6"
					:isLoading="isLoading"
				>
					{{ $t("update") }}
				</j-button>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JList from "@/components/JList"
import JExpendableBox from "@/components/JExpendableBox"
import CoreModal from "@/modules/core/components/CoreModal"
import CrmIcon from "@/components/CrmIcon"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"

import dayjs from "dayjs"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JList,
		JExpendableBox,
		CrmIcon,
		CoreModal,
		CoreFormInput,
		JButton
	},

	data() {
		return {
			isLoading: false,
			itemUpdate: "",
			form: {
				status: this.$store.getters["caseManagement/offer"]?.status,
				startDate: this.$store.getters["caseManagement/offer"]?.startDate,
				endDate: this.$store.getters["caseManagement/offer"]?.endDate
			}
		}
	},

	methods: {
		async updateOffer(key) {
			const query = gql`
				mutation updateOfferOfProposal(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: updateOfferInput!
				) {
					updateOfferOfProposal(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						updateOfferInput: $input
					) {
						status
						errors
					}
				}
			`
			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: this.$store.state.caseManagement.offerId,
				input: {
					[key]: this.form?.[key]
				}
			}

			this.isLoading = true

			const res = await api({ query, variables })

			this.isLoading = false

			if (res?.data?.updateOfferOfProposal?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateOfferOfProposal?.errors ||
							res?.data?.updateOfferOfProposal?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			const stateFilter = function(state) {
				return state.proposals
					?.find(item => item.id === state?.proposalId)
					?.basket?.find(item => item.id === state?.offerId)
			}
			// Update type
			this.$store.commit("caseManagement/UPDATE_CASE", {
				actionType: "update",
				fieldName: key,
				value: this.form?.[key],
				stateFilter
			})

			this.$modal.hide("offerCredentialsUpdate")
		},

		handleUpdateItem(key) {
			this.itemUpdate = key
			this.$modal.show("offerCredentialsUpdate")
		}
	},

	computed: {
		computedFields() {
			const offer = this.$store.getters["caseManagement/offer"]
			const {
				status,
				createdAt,
				createdBy,
				lastModifiedAt,
				lastModifiedBy,
				startDate,
				endDate
			} = offer

			const dateFormat = this.$store.state.settings.dateFormat

			const formattedStatus = status ? status : "---"
			const formattedCreatedAt = createdAt
				? dayjs(createdAt).format(dateFormat)
				: ""
			const formattedLastModifiedAt = lastModifiedAt
				? dayjs(lastModifiedAt).format(dateFormat)
				: ""
			const formattedStartDate = startDate
				? dayjs(startDate).format(dateFormat)
				: ""

			const formattedEndDate = endDate ? dayjs(endDate).format(dateFormat) : ""

			// Return data
			return [
				{
					key: "status",
					label: this.$t("status"),
					value: formattedStatus,
					hasUpdate: true
				},
				{
					key: "createdAt",
					label: this.$t("created_at"),
					value: formattedCreatedAt
				},
				{ key: "", label: this.$t("created_by"), value: createdBy?.username },
				{
					key: "updatedAt",
					label: this.$t("updated_at"),
					value: formattedLastModifiedAt
				},
				{
					key: "updatedBy",
					label: this.$t("updated_by"),
					value: lastModifiedBy?.username
				},
				{
					key: "startDate",
					label: this.$t("start_date"),
					value: formattedStartDate,
					hasUpdate: true
				},
				{
					key: "endDate",
					label: this.$t("end_date"),
					value: formattedEndDate,
					hasUpdate: true
				}
			]
		}
	}
}
</script>
